import { render, staticRenderFns } from "./AddTaskDialog.vue?vue&type=template&id=059d1de4&scoped=true"
import script from "./AddTaskDialog.vue?vue&type=script&lang=js"
export * from "./AddTaskDialog.vue?vue&type=script&lang=js"
import style0 from "./AddTaskDialog.vue?vue&type=style&index=0&id=059d1de4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059d1de4",
  null
  
)

export default component.exports